import { GetPreviewModeOptions } from '../analytics-context-types';
import { getDGModalTag, getPODProductTag } from './utils';

export const getDGViewFacePreview = (options: GetPreviewModeOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const DGFacePreviewModalEvent = [
    {
      eventInfo: {
        eventName: 'area',
        eventAction: options.elementPosition,
      },
    },
    {
      eventInfo: {
        eventName: `view ${options.elementPosition}`,
        eventAction: options.button,
      },
    },
  ];

  const { modal, user } = getDGModalTag('Preview', DGFacePreviewModalEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
